if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      this.isKit = this.form.hasAttribute('data-product-kit');
	  this.oneAtc = this.form.hasAttribute('data-one-atc');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
            this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }

      if (this.isKit) {
        let kitHandle = this.form.closest('.product-kit').getAttribute('data-kit-parent-handle');

        this.getProductJson(kitHandle).then((product) => {
          this.kitProduct = product;
          // this.currencyRate = Number(Shopify.currency.rate);

          if (this.kitProduct.tags) {
            this.kitProduct.tags.some((tag) => {
              if (tag.includes('discount')) {
                this.discountPercent = tag.replace('discount:', '');
                return true;
              }
              return false;
            });
          }
        });
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();
      evt.stopPropagation();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

	  const initialCartResponse = await fetch(`${theme.routes.cart}.js`);
	  if (!initialCartResponse.ok) throw new Error(initialCartResponse.status);
	  const initialCartData = await initialCartResponse.json();

	  let fetchRequestOpts = {};
      let formData = {};

      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

	  const variantInput = this.form.querySelector('input[name="id"]');
	  const packVariantId = parseInt(variantInput.value, 10);
	  const packChildren = variantInput?.dataset.packChildren;
	  const isPreorder = variantInput?.dataset?.preorder === 'true';

        if (this.oneAtc) {
            const section = evt.target.closest('.products-with-one-atc');
            if (!section) return;

            const variantInputs = section.querySelectorAll('product-form:not([data-one-atc="true"]) input[name="id"]');
            const items = [];

            variantInputs.forEach(input => {
                const variantId = parseInt(input.value, 10);
                const isPreorder = input.dataset.preorder === 'true';
                const quantity = 1;

                const properties = {};
                if (isPreorder) {
                    properties['_pre_order'] = true;
                }

                items.push({
                    id: variantId,
                    quantity,
                    ...(Object.keys(properties).length > 0 && { properties })
                });
            });

            if (items.length === 0) return;

            formData['sections_url'] = window.location.pathname;
            formData['sections'] = sections;
            formData['items'] = items.reverse();

            fetchRequestOpts = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(formData)
            };
        } else if (this.isKit) {
          let formsWrapper = evt.target.closest('.kit-container');
          let currentKitId = +formsWrapper.dataset.kitVariantId

          let currentVariants = formsWrapper.querySelectorAll('.kit-item-slider-item.kit-item--current product-form [name="id"]');
          let currentVariantsArray = Array.from(currentVariants);

          let uniqId = new Date().valueOf();

          formData['items'] = currentVariantsArray.map(variant => {
          const isPreorder = variant.dataset.preorder === 'true';
          const quantity = +variant.dataset.qty;
          const variantId = +variant.value;
					const bundleTotalPrice = this.dataset.totalPrice;
	         
          let bundleDisplayPrice = this.kitProduct.price;
          if (this.kitProduct.price === 0 && bundleTotalPrice > 0) {
	          bundleDisplayPrice = bundleTotalPrice;
          }

          const baseProperties = formsWrapper.dataset.kitType === 'custom'
	          ? {
		          _bundleId: 'gid://shopify/ProductVariant/' + currentKitId,
		          _uniqId: uniqId,
		          ...(this.discountPercent && { _percent_discount: this.discountPercent })
	          }
	          : {
		          _bundleId: 'gid://shopify/ProductVariant/' + currentKitId,
		          _uniqId: uniqId,
		          ...(this.discountPercent
			          ? { _percent_discount: this.discountPercent }
			          : { _bundle_price: bundleDisplayPrice })
	          };

	        if (isPreorder) {
		        baseProperties._pre_order = true;
	        }

	        return {
		        id: variantId,
		        quantity: quantity,
		        properties: baseProperties
	        };
        })

        formData['sections_url'] = window.location.pathname;
        formData['sections'] = sections;
        formData['items'].reverse()

        fetchRequestOpts = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        };
      } else {
			formData = new FormData(this.form);
            const variantInput = this.form.querySelector('input[name="id"]');
            const isPreorder = variantInput?.dataset?.preorder === 'true';


            if (isPreorder) {
                formData.append('properties[_pre_order]', "true");
            }

            formData.append('sections_url', window.location.pathname);
            formData.append('sections', sections);

				if (packChildren) {
					const requiredItems = packChildren.split(',').map(entry => {
						const [id, qty] = entry.split(':');
						return { id: parseInt(id, 10), requiredQty: parseInt(qty, 10) };
					});

					try {
						const richCart = await this.getRichCartData();
						if (!richCart) {
							throw new Error('Could not fetch rich cart data for validation.');
						}

						const productContainer = this.closest('.js-product');
						const variantPicker = productContainer?.querySelector('variant-picker');
						if (!variantPicker) {
							console.error('VariantPicker component not found!');
							this.setErrorMsgState('An error occurred. Please refresh.');
							this.submitBtn.removeAttribute('aria-disabled');
							this.submitBtn.classList.remove('is-loading');
							return;
						}

						const mainProduct = variantPicker.getMainProductData();
						const dataFormatted = variantPicker.dataFormatted;
						if (!mainProduct || !dataFormatted) {
							this.setErrorMsgState('Could not retrieve product data for validation.');
							this.submitBtn.removeAttribute('aria-disabled');
							this.submitBtn.classList.remove('is-loading');
							return;
						}

						const flatCartQuantities = {};
						richCart.items.forEach(item => {
							if (item.item_components && item.item_components.length > 0) {
								item.item_components.forEach(component => {
									flatCartQuantities[component.variant_id] = (flatCartQuantities[component.variant_id] || 0) + component.quantity;
								});
							} else {
								flatCartQuantities[item.variant_id] = (flatCartQuantities[item.variant_id] || 0) + item.quantity;
							}
						});

						for (const requiredItem of requiredItems) {
							const totalStock = dataFormatted[requiredItem.id]?.inventory_quantity ?? 0;
							const qtyInCart = flatCartQuantities[requiredItem.id] || 0;
							if (qtyInCart + requiredItem.requiredQty > totalStock) {
								const simpleVariant = mainProduct.variants.find(v => v.id === requiredItem.id);
								const title = simpleVariant ? `"${simpleVariant.name}"` : "that contains in pack";
								this.setErrorMsgState(`The product ${title} is already sold out.`)
								this.submitBtn.removeAttribute('aria-disabled');
								this.submitBtn.classList.remove('is-loading');
								return;
							}
						}
					} catch (e) {
						console.error("Error during pre-cart validation:", e);
					}

					const packDiscountPercent = variantInput.dataset.packDiscount || null;
					const uniqId = new Date().valueOf();

					const baseProperties = {
						_bundleId: `gid://shopify/ProductVariant/${packVariantId}`,
						_uniqId: uniqId,
						...(packDiscountPercent && { _percent_discount: packDiscountPercent }),
					};

					const items = requiredItems.map(item => {
						return {
							id: item.id,
							quantity: item.requiredQty, // Беремо кількість з нашого об'єкта
							properties: baseProperties
						};
					});

					const packFormData = {
						sections_url: window.location.pathname,
						sections: sections,
						items: items.reverse(),
					};

					fetchRequestOpts = {
						method: 'POST',
						credentials: 'same-origin',
						headers: {
							'Content-Type': 'application/json',
							'X-Requested-With': 'XMLHttpRequest'
						},
						body: JSON.stringify(packFormData)
					};
				} else {
					fetchRequestOpts = {
						method: 'POST',
						headers: {
							Accept: 'application/javascript',
							'X-Requested-With': 'XMLHttpRequest'
						},
						body: formData
					};
				}
      }

      const giftInCart = initialCartData.items.filter(function (item) {
          if (item && item.properties != null) {
            item.properties['_product-type'] === "product_gift"
          }
        }
      );

      if (giftInCart.length === 0) {
        if (this.submitBtn.classList.contains('promotion-gift')) {
          let giftProductId = this.submitBtn.getAttribute('data-gift-product');
          let productWithGiftId = this.submitBtn.getAttribute('data-uniq-id');

          let addGift = {
            id: giftProductId,
            quantity: 1,
            properties: {
              '_product-type': 'product_gift',
              '_uniq_id': `${productWithGiftId}`
            }
          };

          await fetch('/cart/add.js', {
            body: JSON.stringify(addGift),
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            method: 'POST'
          });
        }
      }

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(`${theme.routes.cartAdd}.js`, fetchRequestOpts);
        const data = await response.json();
        const error = typeof data.description === 'string' ? data.description : data.message;

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refreshCart();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line

        // Re-enable 'Add to Cart' button.
        this.submitBtn.removeAttribute('aria-disabled');
        this.submitBtn.classList.remove('is-loading');

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg.textContent
          }
        }));
      } finally {
          if (document.querySelector('button.sticky-atc')) {
              document.querySelector('button.sticky-atc').classList.remove('is-loading');
          }
      }
    }

		async getRichCartData() {
			try {
				const response = await fetch('/cart?sections=cart-json');
				if (!response.ok) {
					throw new Error(`Network response was not ok: ${response.statusText}`);
				}
				const sectionsData = await response.json();
				const htmlString = sectionsData['cart-json'];

				const tempDiv = document.createElement('div');
				tempDiv.innerHTML = htmlString;
				const richCart = JSON.parse(tempDiv.textContent);
				return richCart;

			} catch (error) {
				return null;
			}
		}


		/**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];

        const bubbleCountElement = cartIconBubble.querySelector('[aria-hidden="true"]');
        if (bubbleCountElement) {
            const itemCount = Number(bubbleCountElement.textContent);
            if (itemCount > 5 && sessionStorage.getItem('r-pu') !== 'showed') {
                const modal = document.querySelector('.popUp-restoking--modal');
                if (modal) {
                    modal.showModal();
                }
            }
        }
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) this.errorMsg.textContent = error;
    }

    getProductJson(handle) {
      const requestRoute = `${window.theme.routes.root_url}products/${handle}.js`;
      console.log('requestRoute', requestRoute);
      return window
          .fetch(requestRoute)
          .then((response) => {
            return response.json();
          })
          .catch((e) => {
            console.error(e);
          });
    }
  }

  customElements.define('product-form', ProductForm);
}
